// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"e17e632a","139":"e7452f65","872":"abe25bfd","997":"c9a7f341"}[chunkId] + ".chunk.js";
};